'use client'

import { Button, Heading, Paragraph } from '@graftcode/design-system'

import { HERO_SECTION_TEST_IDS } from '@/shared/academy-test-ids.const'

import styles from './HeroSection.module.scss'

interface HeroSectionProps {
  onTryGraftcode: () => void
  onQuickStart: () => void
}

export function HeroSection({ onTryGraftcode, onQuickStart }: HeroSectionProps) {
  return (
    <div className={styles.heroCard} data-testid={HERO_SECTION_TEST_IDS.root}>
      <div className={styles.heroContent}>
        <Heading className={styles.heroTitle} type="h1">
          Graftcode Academy
        </Heading>
        <Paragraph className={styles.heroDescription}>
          The GraftCode Academy contains tutorials, articles and code samples to help you get started with GraftCode.
        </Paragraph>
        <div className={styles.heroButtons}>
          <Button variant="primary" size="l" onClick={onTryGraftcode}>
            Try Graftcode for free
          </Button>
          <Button variant="secondary" size="l" onClick={onQuickStart}>
            Quick start
          </Button>
        </div>
      </div>
    </div>
  )
}
